import { Component } from "@angular/core";
import { select, Store } from "@ngrx/store";
import { take } from "rxjs";
import { DialogService } from "src/app/core/services/dialog.service";
import { SpinnerService } from "src/app/core/services/spinner.service";
import { selectClientId } from "src/app/state/reducer/user.reducer";
import { UserState } from "src/app/state/user-state";
import * as UserActions from "src/app/state/actions/user.actions";

@Component({
  selector: "app-mbc-expiration-dialog",
  templateUrl: "./mbc-expiration-dialog.component.html",
  styleUrls: ["./mbc-expiration-dialog.component.scss"]
})
export class MbcExpirationDialogComponent {
  private clientId: string | undefined;

  constructor(protected dialogService: DialogService,
    protected spinnerService: SpinnerService,
    private store: Store<UserState>) {
  }

  okButtonClick() {
    this.store
      .pipe(select(selectClientId),
        take(1))
      .subscribe((client_ID: string) => {
        this.clientId! = client_ID;
        this.store.dispatch(UserActions.HIDE_EXPIRING_MBC_NOTIFIACTION({ clientId: client_ID }));
      });
  }
}
